import styled from 'styled-components';
import { Typ41, Typ35, Typ32, Typ30 } from 'dc/Typ';
import Btn020 from 'dc/Btn020';
import SpaHR03 from 'dc/SpaHR03';

export const Container = styled.div`
  width: 458px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  margin: 50px 0;
  padding: 56px 85px 53px 85px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 175px;
  height: 175px;
  margin-bottom: 32px;
`;

export const Title = styled(Typ41)`
  margin-bottom: 12px;
`;

export const Text = styled(Typ35)`
  line-height: 19px;
  margin-bottom: 12px;
  text-align: center;
`;

export const EmailAddress = styled(Typ32)`
  margin-bottom: 24px;
`;

export const OtherButton = styled(Btn020)`
  margin-bottom: 16px;
  width: 288px;
  height: 48px;
  span {
    display: inline-block;
    color: #007079;
    text-decoration: underline;
    text-transform: lowercase;
    font-size: 16px;
    line-height: 21px;
  }
`;

export const SpacerLine = styled(SpaHR03)`
  width: 288px;
`;

export const ResendWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  background-color: transparent;
`;

export const NoEmailText = styled(Typ30)`
  color: #607d8b;
  max-width: 180px;
`;

export const ResendButton = styled(Btn020)`
  background-color: transparent;
  border: 0;
  min-width: 120px;
  > span {
    color: #007079;
  }
`;
